import { FormField } from './field';

export class NumberRatingField extends FormField {

    max: number;
    rate: number;
    readonly: boolean;
    resettable: boolean;

    constructor(options: {} = {}) {
        super(options);

        this.max = options['max'] || 5;
        this.rate = options['rate'] || 0;
        this.readonly = options['readonly'] || false;
        this.resettable = options['resettable'] || false;
    }
}
